import React from "react";
import { Typography, Button, Tag } from "antd";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import PatientsList from "../../employeeScheduling/components/PatientsList";
import { useIntl } from "react-intl";
const { Title } = Typography;

const SchedulingHeader = (props) => {
  const {
    currentDate,
    onFilterPatientsChanged,
    onNextDate,
    onPreviousDate,
    order_time_extractions,
    events,
    patientsPallette,
    filteredOrders,
    ordersIds,
  } = props;
  const intl = useIntl();

  const effectiveEvents = events.filter(
    (i) =>
      moment(i.date) > moment(currentDate).startOf("month") &&
      moment(i.date) < moment(currentDate).endOf("month")
  );
  const total =
    Math.round(
      (effectiveEvents.reduce((a, b) => +a + +b.duration_minutes, 0) / 60) * 100
    ) / 100;

  const DatePicker = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "200px",
      }}
    >
      <Tag style={{ margin: 0 }}>
        {`${total} ${intl.formatMessage({
          id: "app.scheduling.totalSceduledHours",
        })}`}
      </Tag>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          width: "200px",
        }}
      >
        <Button
          type="text"
          shape="circle"
          icon={<RightOutlined />}
          onClick={onPreviousDate}
        />
        <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
          {moment(currentDate).format("MMMM YYYY")}
        </Title>
        <Button
          type="text"
          shape="circle"
          icon={<LeftOutlined />}
          onClick={onNextDate}
        />
      </div>
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <DatePicker />
      <PatientsList
        onFilterPatientsChanged={onFilterPatientsChanged}
        ordersIds={ordersIds}
        events={events}
        patientsPallette={patientsPallette}
        filteredOrders={filteredOrders}
        order_time_extractions={order_time_extractions}
      />
    </div>
  );
};

export default SchedulingHeader;
